import type { ReactElement } from "react"
import type {
  BadgeUdsFlatData,
  BadgeUdsVariants,
} from "@gatsby-plugin-generic-page/fragments/badgeUds"
import { Badge } from "@ionos-web-design-system/react"
import DynamicUdsIcon, {
  ICON_GROUP_SQUIDEX_TYPE,
} from "~/components/DynamicUdsIcon"
import isEmpty from "~/lib/isEmpty"

export type BadgeUdsProps = {
  flatData: BadgeUdsFlatData
  className?: string
}

// TODO [ONESTORE-409]: remove uds-tariff-card wrapper + strong/em when ai/blue variants land in UDS badge — these tags are a CSS :has() hack and also carry unintended screen reader semantics (important/emphasis)
export default function BadgeUds({
  flatData,
  className,
}: BadgeUdsProps): ReactElement<BadgeUdsProps> {
  const { variant, text, icon } = flatData

  const isCustomVariant = variant === "ai" || variant === "blue"
  const resolvedVariant = (
    isCustomVariant ? "promo" : variant
  ) as BadgeUdsVariants

  const content = (
    <>
      {!isEmpty(icon) ? (
        <DynamicUdsIcon
          iconName={icon.iconId}
          iconGroup={ICON_GROUP_SQUIDEX_TYPE[icon.__typename]}
          size="xSmall"
          className="shrink-0"
        />
      ) : null}

      {text}
    </>
  )

  return (
    <div className="uds-tariff-card contents">
      <Badge variant={resolvedVariant} className={className}>
        {variant === "ai" ? (
          <strong>{content}</strong>
        ) : variant === "blue" ? (
          <em>{content}</em>
        ) : (
          content
        )}
      </Badge>
    </div>
  )
}
